export const tourGuideSteps = [
  {
    selector: "#client-details-header",
    content:
      "This area shows the summary of the Client information. ",
  },
  {
    selector: "#client-environment-action-button",
    content:
      "Clicking this button provides you with options to enable or suppress email threshold alerts for system events.",
  },
  {
    selector: "#client-environment-default-thresholds-button",
    content:
      "Clicking this button will allow you to enter default values that your MC servers and channels will use as their baseline for threshold comparisons.",
  },
  {
    selector: "#mc-server-info-button",
    content:
      "Clicking this button will load a work area where you can see all details like MC Version, Java Version, and last activity time for all of your registered MC instances.",
  },
  {
    selector: "#manage-licensing-button",
    content:
      "Clicking this button will load the Mirth Connect License details page. On this page you can see all of the Mirth Connect license keys and entitlements.",
  },
  {
    selector: "#client-message-storage-button",
    content:
      "Clicking this button will load the Message Storage report page. On this page you can view S3 storage usage data for all environments and channels.",
  },
  {
    selector: "#environment-metrics-data-grid",
    content:
      "This area allows you to see all of your registered Mirth Connect Environment metrics. Most of the values are total values for the search window. Please note that the queued column represents the most recent queue value reported during the search window.",
  },
  {
    selector: "#Environment-Metrics-column-5",
    content:
      "This column is the number of queued messages at the time of polling. This does not represent the total queue count.",
  },
  {
    selector: "#system-events-filter",
    content:
      "System events are created when queue, error, or inactivity thresholds are exceeded. This set of filters for system events allows users to fine tune the criteria and then search for matching system events.",
  },
];

export const clientEnvironmentActionModalSteps = [
  {
    selector: "#client-environment-action-all-dropdown",
    content:
      "Here is the dropdown selection for the client environment action modal.",
  },
  {
    selector: "#select-action-to-take-column",
    content:
      "Select the action to take for each client environment.",
  },
  {
    selector: "#client-environment-action-cancel-button",
    content:
      "Press this button to cancel and exit the modal.",
  },
  {
    selector: "#client-environment-action-submit-button",
    content:
      "Press this button to submit the action request.",
  },
];

export const clientEnvironmentDefaultThresholdModalSteps = [
  {
    selector: "#default-threshold-type-dropdown",
    content:
      "Here is the dropdown selection for the client environment action modal.",
  },
  {
    selector: "#save-default-threshold-button",
    content:
      "Press this button to send request to change the default threshold.",
  },
  {
    selector: "#cancel-default-threshold-button",
    content:
      "Press this button to cancel and exit the modal.",
  },
];
